import React from "react";
import "./styles.css";

interface ClubePaiEternoProps {
  onClose?: () => void;
}

const ClubePaiEterno: React.FC<ClubePaiEternoProps> = ({ onClose }) => {
  return (
    <div className="clube-overlay">
      <div
        className="clube-modal"
        style={{
          backgroundImage: `url(${'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/fundo-clube.png'})`,
        }}
      >

        <img
          src={'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/Tino.png'}
          alt="tino"
          className="clube-personagem clube-tino"
        />

        <img
          src={'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/Ana.png'}
          alt="aninha"
          className="clube-personagem clube-aninha"
        />

        <img
          src={'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/Vovo.png'}
          alt="Pai Eterno"
          className="clube-vovo"
        />

        <div className="clube-content">

        <div className="clube-header">
    <img
      src={'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/logo-modal.png'}
      alt="Clube do Pai Eterno"
      className="clube-logo"
    />
  </div>

          {/* BLOCO 1 */}
          <div className="clube-info">
            <div className="clube-icon-heart clube-icon-pink">
            <span>
                              <svg
                                viewBox="0 0 100 90"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                              >
                                <path
                                  d="M50 82 C46 78, 12 57, 8 34 C5 18, 15 7, 29 5 C39 4, 47 9, 50 18 C53 9, 61 4, 71 5 C85 7, 95 18, 92 34 C88 57, 54 78, 50 82 Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
            </div>

            <div className="clube-text">
              <p>
                O Clube do Pai Eterno nasceu como um presente especial do
                Santuário Basílica do Divino Pai Eterno para a Família de Amor
                e, principalmente,{" "}
                <strong>
                  para os pequenos devotos de todo o Brasil.
                </strong>
              </p>
            </div>
          </div>

          {/* BLOCO 2 */}
          <div className="clube-info">


          <div className="clube-icon-book clube-icon-yellow">            <span>
          <svg
  viewBox="10 15 52 43"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
>
                                <path
  d="M18 22C18 20.9 18.9 20 20 20H31C33.8 20 36 22.2 36 25V53C34.7 51.4 32.8 50.5 30.5 50.5H20C18.9 50.5 18 49.6 18 48.5V22Z"
  fill="#F9B900"
/>

<path
  d="M54 22C54 20.9 53.1 20 52 20H41C38.2 20 36 22.2 36 25V53C37.3 51.4 39.2 50.5 41.5 50.5H52C53.1 50.5 54 49.6 54 48.5V22Z"
  fill="#F9B900"
/>

<path
  d="M36 25V53"
  stroke="#FFF8DF"
  stroke-width="2"
  stroke-linecap="round"
/>

<path
  d="M23 27H31M23 32H31M23 37H31M23 42H31"
  stroke="#FFF8DF"
  stroke-width="2"
  stroke-linecap="round"
/>

<path
  d="M41 27H49M41 32H49M41 37H49M41 42H49"
  stroke="#FFF8DF"
  stroke-width="2"
  stroke-linecap="round"
/>
                              </svg>
                            </span>
            </div>

            <div className="clube-text">
              <p>
                É um encontro mensal com a fé, levando até as crianças{" "}
                <strong>
                  mensagens de amor, esperança, oração e ensinamentos do
                  Evangelho
                </strong>{" "}
                de um jeito leve, divertido e cheio de carinho.
              </p>
            </div>
          </div>

          {/* BLOCO 3 */}
          <div className="clube-info">
            <div className="clube-icon-home clube-icon-blue">
            <span>
                              <svg
                                viewBox="10 15 52 43"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                              >
                              <path
  d="M16 34L36 17L56 34V54
     C56 55.1 55.1 56 54 56H18
     C16.9 56 16 55.1 16 54V34Z"
  fill="#287BE8"
/>

<path
  d="M11 35L34 15
     C35.1 14 36.9 14 38 15L61 35
     C62.1 36 62.2 37.7 61.2 38.8
     C60.2 39.9 58.5 40 57.4 39L36 20.5L14.6 39
     C13.5 40 11.8 39.9 10.8 38.8
     C9.8 37.7 9.9 36 11 35Z"
  fill="#287BE8"
/>

<path
  d="M30 56V43
     C30 41.3 31.3 40 33 40H39
     C40.7 40 42 41.3 42 43V56H30Z"
  fill="#dcecff"
/>
                              </svg>
                            </span>
            </div>

            <div className="clube-text">
              <p>
                A cada mês, os pequenos recebem em casa{" "}
                <strong>
                  conteúdos preparados especialmente para ajudá-los a crescer
                  na amizade com o Pai Eterno,
                </strong>{" "}
                aprendendo desde cedo que a fé pode caminhar junto com a
                alegria, a imaginação e o amor em família.
              </p>
            </div>
          </div>

          {/* BLOCO 4 */}
          <div className="clube-info clube-last-info">
            <div className="clube-icon-plant clube-icon-green">
            <span>
                              <svg
                                viewBox="10 15 52 43"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                              >
                              <path
  d="M35.5 52
     C34 43 28 36 18 34
     C18 44 24 51 35.5 52Z"
  fill="#4A9D25"
/>

<path
  d="M36 47
     C36 34 42 24 55 20
     C57 33 50 44 36 47Z"
  fill="#62B52F"
/>

<path
  d="M35.5 52
     C35 42 36 33 40 27"
  fill="none"
  stroke="#38851F"
  stroke-width="2.5"
  stroke-linecap="round"
/>
                              </svg>
                            </span>
            </div>
            <div className="clube-text">
              <strong>
                Quando a criança cresce cercada pela presença do Pai Eterno,
                o coração floresce, e a fé também cresce junto!
              </strong>
            </div>
          </div>

          <button className="clube-button" onClick={onClose}>

            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClubePaiEterno;
